<template>
    <div>{{ $t('vfair.privateVFairMessage') }}</div>
</template>

<script>
export default {
    name: 'SchoolVFairInfo',
};
</script>

<style></style>
